import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLockWithStarViolet(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} viewBox="0 0 59 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M22.1623 27.0303V17.9394C22.1623 11.245 27.6861 5.81818 34.5 5.81818C41.3139 5.81818 46.8376 11.245 46.8376 17.9394V20.875M19.0779 60.3636H49.922C53.329 60.3636 56.0909 57.6502 56.0909 54.303V33.0909C56.0909 29.7437 53.329 27.0303 49.922 27.0303H19.0779C15.6709 27.0303 12.9091 29.7437 12.9091 33.0909V54.303C12.9091 57.6502 15.6709 60.3636 19.0779 60.3636Z"
        stroke="url(#lock_with_star_green_svg__a)"
        strokeWidth="5.68182"
      />
      <path
        d="M8.3494 0.690345C8.3494 0.384392 8.10137 0.136368 7.79542 0.136368C7.48947 0.136368 7.24144 0.384392 7.24144 0.690345C7.24144 2.99508 6.73277 4.52809 5.76677 5.49408C4.80078 6.46008 3.26777 6.96875 0.963035 6.96875C0.657082 6.96875 0.409058 7.21678 0.409058 7.52273C0.409058 7.82868 0.657082 8.07671 0.963035 8.07671C3.26777 8.07671 4.80078 8.58538 5.76677 9.55138C6.73277 10.5174 7.24144 12.0504 7.24144 14.3551C7.24144 14.6611 7.48947 14.9091 7.79542 14.9091C8.10137 14.9091 8.3494 14.6611 8.3494 14.3551C8.3494 12.0504 8.85807 10.5174 9.82407 9.55138C10.7901 8.58538 12.3231 8.07671 14.6278 8.07671C14.9338 8.07671 15.1818 7.82868 15.1818 7.52273C15.1818 7.21678 14.9338 6.96875 14.6278 6.96875C12.3231 6.96875 10.7901 6.46008 9.82407 5.49408C8.85807 4.52809 8.3494 2.99508 8.3494 0.690345Z"
        fill="#0D2B57"
      />
      <path
        d="M34.5 38.2045L34.5 46.1591"
        stroke="#0C1C43"
        strokeWidth="0.568182"
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="lock_with_star_green_svg__a"
          x1="34.5"
          y1="5.81818"
          x2="34.5"
          y2="60.3636"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.195043" stopColor="#ADF3C7" />
          <stop offset="1" stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgLockWithStarViolet);
export default ForwardRef;
